let currentStep = 1;
const totalSteps = 5;
const answers = {};
let onPrescriptionScreen = false;

document.addEventListener("DOMContentLoaded", () => {

    const intro = document.getElementById("consultationIntro");
    const app = document.getElementById("consultationApp");
    const startButton = document.getElementById("startConsultation");
    const backButton = document.getElementById("backButton");
    const progressFill = document.getElementById("progressFill");

    startButton.addEventListener("click", () => {

        intro.classList.add("hidden");
        app.classList.remove("hidden");

    });

    backButton.addEventListener("click", backStep);

    document.addEventListener("click", function (e) {

        const card = e.target.closest(".choice-card");

        if (!card) return;

        const step = card.closest(".question");

        step.querySelectorAll(".choice-card").forEach(c => {
            c.classList.remove("selected");
        });

        card.classList.add("selected");

        const key = getQuestionKey(currentStep);

        answers[key] = card.dataset.value;

        setTimeout(nextStep, 350);

    });

    function nextStep() {

        if (currentStep >= totalSteps) {

            document.getElementById("questionContainer").style.display = "none";

            progressFill.style.width = "100%";

            const prescription = document.getElementById("prescriptionScreen");

            prescription.classList.remove("hidden");

            onPrescriptionScreen = true;

            updateBackButtonVisibility();

            setTimeout(generatePrescription, 1200);

            return;

        }

        const currentQuestion = document.querySelector(
            `.question[data-step="${currentStep}"]`
        );

        const nextQuestion = document.querySelector(
            `.question[data-step="${currentStep + 1}"]`
        );

        currentQuestion.classList.remove("active");
        currentQuestion.style.display = "none";

        currentStep++;

        progressFill.style.width = `${(currentStep / totalSteps) * 100}%`;

        nextQuestion.style.display = "block";
        nextQuestion.classList.add("active");

        restoreSelection(currentStep);
        updateBackButtonVisibility();

    }

    function backStep() {

        if (onPrescriptionScreen) {

            onPrescriptionScreen = false;

            document.getElementById("prescriptionScreen").classList.add("hidden");
            document.getElementById("questionContainer").style.display = "block";

            progressFill.style.width = `${(currentStep / totalSteps) * 100}%`;

            restoreSelection(currentStep);
            updateBackButtonVisibility();

            return;

        }

        if (currentStep <= 1) return;

        const currentQuestion = document.querySelector(
            `.question[data-step="${currentStep}"]`
        );

        currentQuestion.classList.remove("active");
        currentQuestion.style.display = "none";

        currentStep--;

        const previousQuestion = document.querySelector(
            `.question[data-step="${currentStep}"]`
        );

        previousQuestion.style.display = "block";
        previousQuestion.classList.add("active");

        progressFill.style.width = `${(currentStep / totalSteps) * 100}%`;

        restoreSelection(currentStep);
        updateBackButtonVisibility();

    }

    function restoreSelection(step) {

        const question = document.querySelector(`.question[data-step="${step}"]`);

        if (!question) return;

        question.querySelectorAll(".choice-card").forEach(c => {
            c.classList.remove("selected");
        });

        const key = getQuestionKey(step);
        const value = answers[key];

        if (!value) return;

        const match = question.querySelector(`.choice-card[data-value="${value}"]`);

        if (match) match.classList.add("selected");

    }

    function updateBackButtonVisibility() {

        backButton.style.display = (currentStep > 1 || onPrescriptionScreen) ? "inline-flex" : "none";

    }

    function getQuestionKey(step) {

        switch (step) {

            case 1:
                return "hairLength";

            case 2:
                return "extensionLength";

            case 3:
                return "density";

            case 4:
                return "ends";

            case 5:
                return "goal";

        }

    }

});

const GRAMS_PER_PACK = {
    "18": 60,
    "22": 70
};

function formatWefts(count) {

    if (!count || count <= 0) return "-";

    const whole = Math.floor(count);
    const isHalf = count % 1 !== 0;

    let numberPart = "";

    if (whole > 0) numberPart += whole;
    if (isHalf) numberPart += "½";

    const label = count <= 1 ? "Weft" : "Wefts";

    return `${numberPart} ${label}`;

}

function gramsForWefts(count, lengthKey) {

    if (!count || count <= 0) return null;

    const perPack = GRAMS_PER_PACK[lengthKey] || GRAMS_PER_PACK["18"];

    return Math.round(count * perPack);

}

function generatePrescription() {

    const prescription = document.getElementById("prescriptionScreen");

    const recommendation = calculateRecommendation();

    const lengthKey = answers.extensionLength || "18";
    const weftsDisplay = formatWefts(recommendation.weftsCount);
    const grams = gramsForWefts(recommendation.weftsCount, lengthKey);
    const gramsDisplay = grams ? `${grams}g` : "-";

    prescription.innerHTML = `

        <div class="prescription">

            <span class="eyebrow">
                YOUR ONLYPRO PRESCRIPTION
            </span>

            <h2>
                ${recommendation.title}
            </h2>

            <div class="value-box">

                <div class="value-row">
                    <span>Hair Required</span>
                    <span>${weftsDisplay}</span>
                </div>

                <div class="value-row">
                    <span>Approx. Grams</span>
                    <span>${gramsDisplay}</span>
                </div>

                <div class="value-row">
                    <span>Installation</span>
                    <span>${recommendation.rows}</span>
                </div>

                <div class="value-savings">
                    ${recommendation.notes}
                </div>

            </div>

        </div>

    `;

}

function calculateRecommendation() {

    const density = answers.density;
    const goal = answers.goal;

    if (goal === "volume") {

        if (density === "fine") {

            return {

                title: "Volume Only",

                weftsCount: 0.5,

                rows: "1 Skeleton Row",

                notes: "Ideal for clients wanting fullness without adding significant length."

            };

        }

        return {

            title: "Volume Only",

            weftsCount: 1,

            rows: "1 Double Row",

            notes: "Recommended for medium to thick hair requiring additional fullness."

        };

    }

    if (goal === "natural") {

        if (density === "fine") {

            return {

                title: "Natural Length and Volume",

                weftsCount: 1,

                rows: "2 Skeleton Rows",

                notes: "Creates soft natural fullness while maintaining maximum comfort."

            };

        }

        return {

            title: "Natural Length and Volume",

            weftsCount: 2,

            rows: "2 Double Rows",

            notes: "Provides balanced fullness with excellent coverage."

        };

    }

    if (goal === "transformation") {

        if (density === "fine") {

            return {

                title: "Full Transformation",

                weftsCount: 2,

                rows: "3 Skeleton Rows",

                notes: "Designed for dramatic length and volume on finer hair."

            };

        }

        if (density === "medium") {

            return {

                title: "Full Transformation",

                weftsCount: 3,

                rows: "3 Double Rows",

                notes: "Creates maximum density with seamless blending."

            };

        }

        return {

            title: "Maximum Volume",

            weftsCount: 3.5,

            rows: "3 Double Rows",

            notes: "Our fullest recommendation for naturally thick hair."

        };

    }

    return {

        title: "Consultation Complete",

        weftsCount: 0,

        rows: "-",

        notes: ""

    };

}
